import React from 'react';
import { useParams } from "react-router";
import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { ResponsiveTable } from "../../../../layout/Table/ResponsiveTable";

function TableComponent(props) {
  const { id } = useParams();

    return (
      <ResponsiveTable>
        <TableHead
          shouldRenderFields={ props.shouldRenderFields }
          applySort={ props.applySort } />
        <TableBody
          shouldRenderFields={ props.shouldRenderFields }
          coupons={ props.coupons }
          campaign_id={ id }
          actionCallback={ props.actionCallback }
          couponCreated = { props.couponCreated }
        />
      </ResponsiveTable>
    )
}

export { TableComponent };
